
import { defineComponent, onMounted, ref } from "vue";

export default defineComponent({
	setup: (_, context) => {
		const container = ref();
		onMounted(() => {
			if (container.value instanceof HTMLElement)
				context.emit("emitUp", container.value.scrollHeight);
		});
		return { container };
	},
});
